<template lang="pug">
  .auth-form__wrap
    .auth-form.auth-form--restore
      .auth-form__logo
      h1.auth-form__caption.text-center Сброс пароля
      p.auth-form__note Введите новый пароль для личного кабинета
      ValidationObserver(v-slot="{ handleSubmit, invalid}")
        form(method='POST' @submit.prevent="handleSubmit(reset)")
          ValidationProvider.auth-form__row(
            rules="required|confirmed:confirmation|password-strength"
            v-slot="{ errors }"
          )
            input#email.form-control(
              type='password',
              placeholder='Новый пароль',
              autofocus='true',
              v-model='password'
              v-bind:class="{ error: errors[0] }"
            )
            span(v-if="errors[0]").auth-form__error {{ errors[0] }}
          ValidationProvider.auth-form__row(
            rules="required"
            v-slot="{ errors }"
            vid="confirmation"
          )
            input#email.form-control(
              type='password',
              placeholder='Повторите пароль',
              autofocus='',
              v-model='confirmation'
              v-bind:class="{ error: errors[0] }"
            )
            span(v-if="errors[0]").auth-form__error {{ errors[0] }}
          .restore__button-row
            button.auth-form__submit.restore__submit(type="submit" :disabled="invalid") Восстановить
          .auth-form__footer
            a.auth-form__label.auth-form__link(:href="registerUrl") Регистрация

</template>

<script>
import apiClient from '@/apiClient';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, confirmed } from 'vee-validate/dist/rules';
import config from '@/config';

extend('email', {
  ...email,
  message: 'Email указан не верно'
});

extend('required', {
  ...required,
  message: 'Обязательно'
});

extend('confirmed', {
  ...confirmed,
  message: 'Пароли должны совпадать'
});

export default {
  props: {
    token: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      password: '',
      confirmation: ''
    };
  },

  computed: {
    registerUrl: () => config.urls.registration
  },

  methods: {
    reset() {
      new Promise((resolve, reject) => {
        apiClient
          .post(`/auth/reset/${this.token}`, {
            password: this.password
          })
          .then(resp => {
            this.flashSuccess(
              'Пароль успешно изменен: вы будете перенаправлены на страницу входа'
            );
            setTimeout(() => this.$router.push({ name: 'login' }), 1000);
            resolve(resp);
          })
          .catch(err => {
            this.flashError('Произошла ошибка. Пароль не был изменен');
            reject(err);
          });
      });
    }
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
};
</script>

<style lang="scss" src="../Auth.scss"></style>

<style lang="scss">
.auth-form--restore {
  max-width: 270px !important;
}

.restore {
  &__button-row {
    display: flex;
  }

  &__submit {
    width: 100%;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &__cancel {
    flex-shrink: 0;
    width: 95px;
  }
}
</style>
